'use client';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', backgroundColor: 'var(--background)' }}>
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2.5 group">
            <div className="flex items-center">
              <Image
                alt="Dr Physio Logo"
                width={40}
                height={40}
                className="flex-shrink-0 object-contain"
                src="/assets/images/image-1785949098149.png" />
            </div>
            <span className="font-display font-bold text-base hidden sm:block" style={{ color: 'var(--foreground)' }}>Dr Physio</span>
          </Link>

          {/* Nav Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {[
            { label: 'Services', href: '/services' },
            { label: 'How It Works', href: '/#how-it-works' },
            { label: 'Contact', href: '/contact' },
            { label: 'Privacy', href: '/contact' },
            { label: 'Terms', href: '/contact' }]?.map((item) =>
            <Link
              key={item?.label}
              href={item?.href}
              className="text-sm font-medium transition-colors duration-200 min-h-[44px] flex items-center"
              style={{ color: 'var(--muted-foreground)' }}>
              {item?.label}
            </Link>
            )}
          </nav>

          {/* Social + Copyright */}
          <div className="flex items-center gap-4" style={{ color: 'var(--muted-foreground)' }}>
            <a
              href="https://www.instagram.com/drphysiokochi?igsh=MXdoNmc1Ym9ncHp5Zw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="transition-opacity hover:opacity-70 min-h-[44px] min-w-[44px] flex items-center justify-center">
              <span style={{ background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)', borderRadius: '6px', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18" height="18">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </span>
            </a>
            <a
              href="https://www.facebook.com/share/1DEzK6vaM7/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="transition-colors hover:opacity-70 min-h-[44px] min-w-[44px] flex items-center justify-center"
              style={{ color: '#1877F2' }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <span className="text-xs hidden md:block" style={{ color: 'var(--muted-foreground)' }}>&copy; 2026 Dr Physio</span>
          </div>
        </div>

        {/* Mobile copyright */}
        <p className="text-center text-xs mt-6 md:hidden" style={{ color: 'var(--muted-foreground)' }}>
          &copy; 2026 Dr Physio. All rights reserved.
        </p>
      </div>
    </footer>
  );
}